// extracted by mini-css-extract-plugin
module.exports = {"Image":"Image_Image__aG1fW","Image--Loaded":"Image_Image--Loaded__IwxD1"};